<app-collapsible-container [id]="'adminData'"
                           [title]="'REPERTOIRE.FORMS.PERSONAL-DATA.TITLE'"
                           [icon]="'i-user'"
                           (elementSizeModification)="elementSizeModification.emit()"
>
    <ng-container *appCheckPermissions="permissions.repertoire_is_active_switch_change">
        <div *ngIf="isEdit" class="form-control">
            <app-switch-input [formControl]="isActive"
                              [title]="'REPERTOIRE.FORMS.IS-ACTIVE.TITLE'"
            >
            </app-switch-input>
        </div>
    </ng-container>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.ADMIN-FIRSTNAME' | translate }}</label>
        <app-basic-input
            [formControl]="firstname"
            [icons]="'i-user'"
            [inputConfig]="{
                                        placeholder: 'Marc',
                                        inputId: 'firstname',
                                        type: basicInputTypeEnum.TEXT
                                    }"
            [maxLength]="255"
            [isValid]="firstname.valid"
        >
        </app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.ADMIN-LASTNAME' | translate }}</label>
        <app-basic-input
            [formControl]="lastname"
            [icons]="'i-user'"
            [inputConfig]="{
                                        placeholder: 'Aurèle',
                                        inputId: 'lastname',
                                        type: basicInputTypeEnum.TEXT
                                    }"
            [maxLength]="255"
            [isValid]="lastname.valid"
        >
        </app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.EMAIL' | translate }}</label>
        <app-basic-input
            [formControl]="email"
            [icons]="'i-at'"
            [inputConfig]="{
                                        placeholder: 'REPERTOIRE.FORMS.PERSONAL-DATA.EMAIL-PERSON-PLACEHOLDER',
                                        inputId: 'email',
                                        type: basicInputTypeEnum.EMAIL
                                    }"
            [maxLength]="255"
            [isValid]="email.valid"
        >
        </app-basic-input>
    </div>
</app-collapsible-container>

